// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"1aac085d","213":"e8a060db","239":"2e2cf405","306":"74131059","307":"3636f244","337":"6b0f473a","410":"f20c3907","412":"a18206a1","487":"10542a5d","664":"25b96bd4","732":"48ca02c3","773":"4c4434c2","813":"22d9b210","977":"8c425e9a"}[chunkId] + ".chunk.js";
};